
<template>
  <v-app>
    <v-app-bar
      app
      clipped-left
      v-if="! isEmbedded "
    >
      <div class="d-flex align-center">
        <v-img
          alt="risQ"
          class="shrink mr-2"
          contain
          :src="require('@/assets/ICE_logo_rgb.png')"
          transition="scale-transition"
          width="40"
        />
        <v-toolbar-title
          class="mx-2"
        >
          {{appName}}
        </v-toolbar-title>
      </div>
      <v-spacer />
      <user-menu>
      </user-menu>
    </v-app-bar>
    <v-navigation-drawer
      permanent
      :mini-variant.sync="navIsHidden"
      :dark="navDark"
      color="primary"
      app
      clipped
    >
      <v-divider />

      <v-list
        nav
      >
        <v-list-item-group
          v-for="item in navItems"
          :key="item.label"
        >
          <v-divider v-if="item.header" class="mx-6"></v-divider>
          <v-list-item
            v-if="showNavItem(item)"
            link
            :to="item.path"
            :href="item.href"
            :disabled="item.coming_soon"
            :two-line="(item.coming_soon || item.header || item.new) && ! navIsHidden"
          >
            <v-list-item-icon>
              <v-icon :disabled="item.coming_soon">
                {{ item.icon }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-subtitle v-if="item.header">{{item.header}}</v-list-item-subtitle>
              <v-list-item-title>{{ item.label == "Home" ? homeLabel : item.label }}</v-list-item-title>
              <v-list-item-subtitle
                v-if="item.coming_soon && ! navIsHidden"
                style="font-style:italic;"
              >
                Coming soon
              </v-list-item-subtitle>
              <v-list-item-subtitle
                v-if="item.new && ! navIsHidden"
              >
                <v-chip x-small color="indigo">New!</v-chip>
              </v-list-item-subtitle>

            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <template v-slot:append>
        <div class="d-flex justify-center">
          <v-spacer v-if="! navIsHidden" />
          <v-btn
            icon
            class="ma-1"
            outlined
            @click.stop="navIsHidden = !navIsHidden"
          >
            <v-icon
              v-if="navIsHidden"
              large
            >
              mdi-chevron-right
            </v-icon>
            <v-icon v-if="! navIsHidden">
              mdi-chevron-left
            </v-icon>
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
    <v-main>
      <router-view />
    </v-main>
    <v-footer app dark color="#333">
      <v-spacer></v-spacer>
      <div class="split-right foot" >
          <ul class="text-right spacer-xs">
            <li>
              <a title="Terms of Use" href="https://www.theice.com//terms-of-use" class="txt">Terms of Use</a>
            </li>
            <li>
              <a title="Privacy Policy" href="https://www.theice.com//privacy-policy" class="txt">Privacy Policy</a>
            </li>
            <li class="hidden-xs">
              <a title="Security" href="https://www.theice.com//security" class="txt">Security</a>
            </li>
            <li>
              <a title="Cookies" href="https://www.theice.com//cookies" class="txt">Cookies</a>
            </li>

            <li>
              <a title="Data Protection" href="https://www.theice.com//data-protection" class="txt">Data Protection</a>
            </li>
            <li>
              <a title="Registered Investment Adviser Notice" href="https://www.theice.com//registered-investment-adviser-notice" class="txt">Registered Investment Adviser Notice</a>
            </li>
          </ul>
        </div>
      <v-spacer></v-spacer>
      <div class="foot mr-6">&copy; {{ (new Date()).getFullYear() }}   Intercontinental Exchange, Inc.</div>
      <v-menu
        top
        offset-y
        dense
      >
      <template v-slot:activator="{ on }">
        <v-btn text icon x-small color="#666" v-on="on" style="position:absolute;right:5px;">
          <v-icon>mdi-cog</v-icon>
        </v-btn>
      </template>
      <v-card width="400px" style="margin-bottom:7px;">
        <v-card-title color="primary" dark>
          About
        </v-card-title>
        <v-card-text>
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <tr>
                  <td>UI Version</td>
                  <td>1.1.1</td>
                </tr>
                <tr
                  v-for="value,detail in about"
                  :key="detail"
                >
                  <td>{{ detail }}</td>
                  <td>{{ value }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
      </v-menu>
    </v-footer>
  </v-app>
</template>

<script>
import { mapState } from 'vuex'
import UserMenu from '../components/UserMenu.vue'
export default {
  name: 'App',

  components: {
    UserMenu
  },
  computed: {
    isEmbedded: function() {
      return this.$cookies.get('embed')
    },
    homeLabel: function() {
      return this.isEmbedded ? 'MBS UI Home' : 'Home'
    },
    navIsHidden: {
      get() { return this.navMini },
      set(val) { this.$store.dispatch('updateState',['navMini',val]) }
    },
    year: function() {
      return new Date().getFullYear()
    },
    ...mapState({
      navMini: (state) => state.navMini,
      appName: (state) => state.appName,
      about: (state) => state.about,
      user: 'user'
    })
  },
  methods: {
    showNavItem: function(item) {
      if (this.user) {
        if (item.allow_for_trials && this.user.trial) {
          return true
        } else if (item.require_account_ids) {
          if (item.require_account_ids.includes(this.user.account.id)) {
            return true
          } else {
            return false
          }
        }
      } else {
        return false
      }
      return true
    }
  },
  data: () => ({
    navDark: true,
    navItems: [
      { path: '/', icon: 'mdi-home', label: 'Home', coming_soon: false },
      { path: '/collections', icon: 'mdi-folder', label: 'My Files', coming_soon: false },
      { path: '/securities', icon: 'mdi-table-search', label: 'Explore securities', coming_soon: false },
      { path: '', icon: 'mdi-bookshelf', label: 'Document Library', coming_soon: false, href: 'https://docs.level11analytics.com/', new: true },
      { path: '/custom_locations', icon: 'mdi-map-marker-plus-outline', label: 'Custom locations', allow_for_trials: true, require_account_ids: [1,7,20,36,32,97,99,102,103,105,106,77], header: 'ESG Geo Analyzer'},
      { path: '/locations', icon: 'mdi-map-search-outline', label: 'Explore locations', require_account_ids: [1,7,20,36], header: 'Demonstration datasets'}
    ]
    /* ,
    items: [
      {icon: title:, route: }
    ]
    */
  })
}
</script>
<style scoped>
#copyright {font-size: 0.8em}
footer ul li {display:inline; margin: 5px 10px;}
div.foot { color:#999;}
footer ul li a {text-decoration: none;  color:#999; font-size:0.9em; font-weight: 700}

</style>
